import type { CalendarEventActionSource } from './CalendarEventActionSource';
import { getDefaultCalendar } from 'owa-calendar-cache';
import { initializeCalendarsCache, CalendarEndpointType } from 'owa-calendar-cache-loader';
import { newCalendarEvent } from 'owa-calendar-events-actions';
import { getCalculatedFolderId } from 'owa-calendar-properties';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export default async function createCalendarEvent(
    actionSource: CalendarEventActionSource,
    event: Partial<CalendarEvent>
) {
    await initializeCalendarsCache(CalendarEndpointType.Outlook);

    // NOTE: maybe I can use just folderNameToId when dealing with the user's mailbox only.
    // Or we need to add more stuff to deal with group mailboxes, when we add support for it.
    const defaultCalendar = getDefaultCalendar()!;
    event.ParentFolderId = {
        Id: getCalculatedFolderId(defaultCalendar).Id,
        mailboxInfo: defaultCalendar.calendarId.mailboxInfo,
    };

    const newEvent = await new Promise<CalendarEvent>((resolve, reject) => {
        newCalendarEvent(event as CalendarEvent, actionSource, resolve, reject);
    });

    return newEvent;
}
